<template>
    <div>
        <div class="relative flex flex-col h-screen">
            <img :src="getImage('mascot')" class="fixed papsi-mascot">
            <div class="flex flex-1 lg:flex-row flex-col">
                <SidebarSection>
                    <LabelControl type="message" :content="$t('mip001')" />
                </SidebarSection>
                <ContentSection @logout="logout">
                    <div class="flex flex-row items-center justify-between">
                        <LabelControl type="heading" :content="$t('mip013')" />
                        <div @click="toggleEditPINModal"
                            class="flex flex-row text-center align-middle bg-grey-lighter px-5 py-3 rounded-xl border-grey text-3xl font-bold text-grey-darker">
                            <img :src="getIcon('pin')" class="mr-2 w-8 icon">
                            <p>Edit PIN</p>
                        </div>
                    </div>
                    <EditPINModalControl ref="EditPINModal" />
                    <div class="bg-grey-lighter p-10 mt-10 rounded-xl container">
                        <div class="flex flex-row align-center justify-start">
                            <div @click="toggle_qr = true"
                                class="flex flex-col bg-white p-3 rounded-xl justify-center align-middle items-center text-center w-48">
                                <img :src="getIcon('user-card')" class="w-32 h-32">
                                <p class="mt-2 text-xl uppercase font-medium bg-grey-light py-2 px-4 rounded-xl">View QR
                                </p>
                            </div>

                            <div class="flex flex-col align-center justify-center ml-12 w-full">
                                <p class="text-grey-darkest font-bold uppercase text-4xl mb-3">{{ maskedName }}</p>
                                <div class="w-full cards-grid-top mb-2">
                                    <p class="text-grey-dark font-semibold text-3xl">{{ $t('mip002') }}: <span
                                            class="font-normal">{{ maskedAccountNumber }}</span></p>
                                    <p class="text-grey-dark font-semibold text-3xl">{{ $t('mip003') }}: <span
                                            class="font-normal">{{ maskedSerialNumber }}</span></p>
                                </div>
                                <p class="text-grey-dark font-semibold text-3xl">{{ $t('mip004') }}:
                                    <span class="font-normal capitalize">{{member_type.replace(/^(\w)(\w*)/, (_, first,
                                        rest) => first.toUpperCase() +
                                        rest.toLowerCase())}}</span>
                                </p>
                            </div>
                        </div>
                        <div class="cards-grid mt-16">
                            <div class="flex flex-col">
                                <div class="flex flex-row justify-between">
                                    <p class="text-grey-darkest text-3xl mb-4">{{ $t('mip005') }}</p>
                                    <IconControl class="ml-auto" @click="toggleEditMobileModal" id="edit" :height="40"
                                        :width="40" />
                                </div>

                                <div class="flex flex-row bg-white rounded-lg px-6 py-4 justify-between">
                                    <div class="flex flex-row">
                                        <IconControl id="smartphone" :height="35" :width="35" class="mr-5" />
                                        <p class="text-grey-darkest text-3xl">{{ showMobile ? getMobile : maskedMobile
                                            }}</p>
                                    </div>
                                    <div class="ml-auto flex items-center">
                                        <img v-if="getMobile"
                                            :src="getIcon(showMobile ? 'password_visible' : 'password_invisible')"
                                            class="w-8 h-8" @click="toggleVisibility('mobile')" />
                                    </div>
                                    <OTPModalControl ref="MobileEditModal" />
                                </div>
                            </div>
                            <div class="flex flex-col">
                                <div class="flex flex-row justify-between">
                                    <p class="text-grey-darkest text-3xl mb-4">{{ $t('mip006') }}</p>
                                    <IconControl class="ml-auto" @click="toggleEditEmailModal" id="edit" :height="40"
                                        :width="40" />
                                </div>
                                <div class="flex flex-row bg-white rounded-lg px-6 py-4 items-center justify-between">
                                    <div class="flex flex-row items-center">
                                        <IconControl id="mail" :height="35" :width="35" class="mr-5" />
                                        <p
                                            :class="getEmail && getEmail.length > 26 ? 'text-grey-darkest text-xl' : 'text-grey-darkest text-2xl'">
                                            {{ showEmail ? getEmail : maskedEmail }}</p>
                                    </div>

                                    <div class="ml-auto flex items-center">
                                        <img v-if="getEmail"
                                            :src="getIcon(showEmail ? 'password_visible' : 'password_invisible')"
                                            class="w-8 h-8 cursor-pointer" @click="toggleVisibility('email')" />
                                    </div>

                                    <OTPModalControl :type="6" ref="getEmailEditModal" />
                                </div>
                            </div>
                            <div class="flex flex-col">
                                <div class="flex flex-row justify-between">
                                    <p class="text-grey-darkest text-3xl mb-4">{{ $t('mip007') }}</p>
                                    <IconControl class="ml-auto" v-if="!birthdate" @click="toggleAddBirthdayModal"
                                        id="add" :height="40" :width="40" />
                                </div>
                                <div class="flex flex-row bg-white rounded-lg px-6 py-4 justify-between">
                                    <div class="flex flex-row">
                                        <IconControl id="birthday" :height="35" :width="35" class="mr-5" />
                                        <p v-if="birthdate" class="text-grey-darkest text-3xl">{{
                                            showBirthdate ? this.formatDate(getBirthdate) : maskedBirthdate }}</p>
                                        <p v-else class="text-grey-dark text-3xl"></p>
                                    </div>
                                    <img :src="getIcon(showBirthdate ? 'password_visible' : 'password_invisible')"
                                        v-if="birthdate" class="w-8 h-8" @click="toggleVisibility('birthdate')" />

                                    <EditBirthdayModalControl :is_visible="toggle_add_birthdate"
                                    @close="toggle_add_birthdate = false" @birthdate-updated="toggleMessage" />


                                </div>
                            </div>
                            <div class="flex flex-col">

                                <div class="flex flex-row justify-between">
                                    <p class="text-grey-darkest text-3xl mb-4">{{ $t('mip008') }}</p>
                                    <IconControl v-if="!tin" class="ml-auto" @click="toggleAddTINModal" id="add"
                                        :height="40" :width="40" />
                                </div>
                                <div class="flex flex-row bg-white rounded-lg px-6 py-4 justify-between">
                                    <div class="flex flex-row">
                                        <IconControl id="id_card" :height="35" :width="35" class="mr-5" />
                                        <p v-if="tin" class="text-grey-darkest text-3xl">{{ showTIN ? getTIN : maskedTIN
                                            }}</p>
                                        <p v-else class="text-grey-dark text-3xl"></p>
                                    </div>

                                    <img :src="getIcon(showTIN ? 'password_visible' : 'password_invisible')" v-if="tin"
                                        class="w-8 h-8" @click="toggleVisibility('TIN')" />

                                    <EditTINModalControl :is_visible="toggle_add_tin" @close="toggle_add_tin = false" />

                                </div>
                            </div>

                        </div>
                    </div>

                    <!-- Toggle QR -->
                    <transition name="slide-in">
                        <ModalControl v-show="toggle_qr" :is_visible="toggle_qr" is_qr>
                            <div class="flex justify-center text-center align-middle py-12 relative">
                                <qrcode-vue :value="qr || ''" :size="500" level="H" />
                                <IconControl @click="toggle_qr = false" id="exit-black" :width="50" :height="50"
                                    class="absolute" style="top: -10px; right:-10px;" />
                            </div>
                        </ModalControl>
                    </transition>

                    <!-- Existing Session -->
                    <transition name="slide-in">
                        <ModalControl :is_visible="existing_session">
                            <SessionTimeoutControl />
                        </ModalControl>
                    </transition>

                    <!-- Update successful -->
                    <transition name="slide-in">
                        <ModalControl v-if="toggle_message" :is_visible="toggle_message">
                            <div class="flex flex-col justify-center align-center items-center p-8">
                                <img :src="getIcon('check')" class="mb-10">
                                <LabelControl type="heading"
                                    class="text-grey-darkest font-bold text-5xl mb-8 text-center"
                                    :content="$t('mip016')" />
                                <div class="flex w-full text-center justify-center align-center items-center">
                                    <ButtonControl :text="$t('btn014')" theme="success" @click="toggleMessage" />
                                </div>
                            </div>
                        </ModalControl>
                    </transition>

                    <!-- Privacy Policy -->
                    <transition name="slide-in">
                        <ModalControl :is_visible="this.toggle_privacy" is_scrollable is_table :overlay_enabled="true">
                            <div class="flex flex-col justify-center pt-10 px-10">
                                <LabelControl type="dynamic"
                                    class="text-grey-darkest font-bold text-6xl mb-8 uppercase text-center"
                                    content="Privacy Policy" />
                                <PrivacyPolicyControl />
                                <div class="flex flex-row justify-center align-center items-center w-full" style="gap: 3rem;">
                                    <ButtonControl text="I Disagree" theme="error" @click="toggle_privacy = false" class="w-full" />
                                    <ButtonControl 
                                        text="I Agree" 
                                        class="px-8 mr-5 w-full" 
                                        theme="success" 
                                        @click="
                                            nextActionMobile ? handlePrivacyAgreementMobile() :
                                            nextActionEmail ? handlePrivacyAgreementEmail() :
                                            nextActionBirthday ? handlePrivacyAgreementBirthday() :
                                            nextActionTIN ? handlePrivacyAgreementTIN() :
                                            handlePrivacyAgreementPIN()
                                        " />
                                </div>
                            </div>
                        </ModalControl>
                    </transition>

                </ContentSection>
            </div>

            <FooterSection />
        </div>
    </div>

</template>

<script>
import SidebarSection from '@/components/sections/SidebarSection.vue';
import ContentSection from '@/components/sections/ContentSection.vue';
import FooterSection from '@/components/sections/FooterSection.vue';
import LabelControl from '@/components/controls/LabelControl.vue';
import IconControl from '@/components/controls/IconControl.vue';
import OTPModalControl from '@/components/controls/OTPModalControl.vue';
import ModalControl from '@/components/controls/ModalControl.vue';
import ButtonControl from '@/components/controls/ButtonControl.vue';
import SessionTimeoutControl from '@/components/controls/SessionTimeoutControl.vue';
import EditPINModalControl from '@/components/controls/EditPINModalControl.vue';
import PrivacyPolicyControl from '@/components/controls/PrivacyPolicyControl.vue';
import mixin from '@/mixins/controls.js';
import QrcodeVue from 'qrcode.vue'
import EditBirthdayModalControl from '@/components/controls/EditBirthdayModalControl.vue';
import EditTINModalControl from '@/components/controls/EditTINModalControl.vue';

export default {
    mixins: [mixin],
    inject: ['setLoading', 'setError'],
    components: {
        SidebarSection,
        ContentSection,
        FooterSection,
        LabelControl,
        IconControl,
        QrcodeVue,
        OTPModalControl,
        ModalControl,
        ButtonControl,
        SessionTimeoutControl,
        EditPINModalControl,
        EditBirthdayModalControl,
        EditTINModalControl,
        PrivacyPolicyControl,
    },
    data() {
        return {
            toggle_add_birthdate: false,
            toggle_add_tin: false,
            toggle_message: false,
            toggle_qr: false,
            toggle_privacy: false,
            existing_session: false,
            hasAgreedToPrivacyMobile: false,
            hasAgreedToPrivacyEmail: false,
            hasAgreedToPrivacyBirthday: false,
            hasAgreedToPrivacyTIN: false,
            hasAgreedToPrivacyPIN: false,
            nextActionMobile: null,
            nextActionEmail: null,
            nextActionBirthday: null,
            nextActionTIN: null,
            nextActionPIN: null,
            account_name: "",
            account_number: "",
            serial_number: "",
            member_type: "",
            birthdate: "",
            tin: "",
            qr: "",
            hash: "",
            otp: "",
            pin: "",
            selected_year: "",
            selected_month: "",
            selected_day: "",
            inputted_tin: false,
            showMobile: false,
            showEmail: false,
            showBirthdate: false,
            showTIN: false,
            loading: false,
        }
    },
    computed: {
        getMobile() {
            return this.$store.state.user.mobile;
        },
        getEmail() {
            return this.$store.state.user.email;
        },
        getBirthdate() {
            return this.$store.state.user.birthdate;
        },
        getTIN() {
            return this.$store.state.user.tin;
        },
        maskedMobile() {
            return this.maskData(this.getMobile, 'mobile');
        },
        maskedEmail() {
            return this.maskData(this.getEmail, 'email');
        },
        maskedBirthdate() {
            if (!this.getBirthdate) return "";

            // Convert YYYY-MM-DD to MM/DD/YYYY
            const [year, month, day] = this.getBirthdate.split("-");
            const formattedDate = `${month}/${day}/${year}`;

            return this.maskData(formattedDate, "birthdate");
        },
        maskedTIN() {
            return this.maskData(this.getTIN, 'tin');
        },
        maskedName() {
            return this.maskData(this.account_name, 'name');
        },
        maskedAccountNumber() {
            return this.maskData(this.account_number, 'account');
        },
        maskedSerialNumber() {
            return this.maskData(this.serial_number, 'serial');
        },
    },
    mounted() {
        this.$emit('checkauth');
        const state = this.$store.state.user;
        this.account_name = `${state.last_name}, ${state.first_name} ${state.middle_name}`;
        this.account_number = state.account_number || '';
        this.serial_number = state.serial_number || '';
        this.member_type = state.membership_type || '';
        this.birthdate = state.birthdate || '';
        this.hash = state.hash || '';
        this.tin = state.tin || '';
        this.qr = state.qr || '';
        this.uuid = state.uuid || '';

    },
    methods: {
        toggleMessage() {
            // console.log('Toggling message modal');
            this.toggle_message = !this.toggle_message;
            // console.log('toggle_message:', this.toggle_message);
        },
        toggleEditMobileModal() {
            if (!this.$store.state.user.hasAgreedToPrivacyMobile) {
                this.toggle_privacy = true; // Show privacy modal first
                this.nextActionMobile = () => this.$refs.MobileEditModal.openEditModal(); // Store the next action
            } else {
                this.$refs.MobileEditModal.openEditModal(); // Open OTP modal directly if already agreed
            }
        },
        toggleEditEmailModal() {
            if (!this.$store.state.user.hasAgreedToPrivacyEmail) {
                this.toggle_privacy = true; // Show privacy modal first
                this.nextActionEmail = () => this.$refs.getEmailEditModal.openEditModal(); // Store the next action
            } else {
                this.$refs.getEmailEditModal.openEditModal(); // Open OTP modal directly if already agreed
            }
        },
        toggleAddBirthdayModal() {
            if (!this.$store.state.user.hasAgreedToPrivacyBirthday) {
                this.toggle_privacy = true; // Show privacy modal first
                this.nextActionBirthday = () => {
                    this.toggle_add_birthdate = true; // Open birthday modal
                };
            } else {
                this.toggle_add_birthdate = true; // Open birthday modal directly if already agreed
            }
        },
        toggleAddTINModal() {
            if (!this.$store.state.user.hasAgreedToPrivacyTIN) {
                this.toggle_privacy = true; // Show privacy modal first
                this.nextActionTIN = () => {
                    this.toggle_add_tin = true; // Open TIN modal
                };
            } else {
                this.toggle_add_tin = true; // Open TIN modal directly if already agreed
            }
        },
        toggleEditPINModal() {
            if (!this.$store.state.user.hasAgreedToPrivacyPIN) {
                this.toggle_privacy = true; // Show privacy modal first
                this.nextActionPIN = () => this.$refs.EditPINModal.openEditModal(); // Store the next action
            } else {
                this.$refs.EditPINModal.openEditModal(); // Open PIN modal directly if already agreed
            }
        },
        handlePrivacyAgreementMobile() {
            this.$store.commit('updateHasAgreedToPrivacy', { field: 'hasAgreedToPrivacyMobile', value: true });
            this.toggle_privacy = false; // Close privacy modal
            if (this.nextActionMobile) {
                this.nextActionMobile(); // Execute the stored action (open OTP modal for mobile)
                this.nextActionMobile = null; // Clear the stored action
            }
        },
        handlePrivacyAgreementEmail() {
            this.$store.commit('updateHasAgreedToPrivacy', { field: 'hasAgreedToPrivacyEmail', value: true });
            this.toggle_privacy = false; // Close privacy modal
            if (this.nextActionEmail) {
                this.nextActionEmail(); // Execute the stored action (open OTP modal for email)
                this.nextActionEmail = null; // Clear the stored action
            }
        },
        handlePrivacyAgreementBirthday() {
            this.$store.commit('updateHasAgreedToPrivacy', { field: 'hasAgreedToPrivacyBirthday', value: true });
            this.toggle_privacy = false; // Close privacy modal
            if (this.nextActionBirthday) {
                this.nextActionBirthday(); // Execute the stored action (open birthday modal)
                this.nextActionBirthday = null; // Clear the stored action
            }
        },
        handlePrivacyAgreementTIN() {
            this.$store.commit('updateHasAgreedToPrivacy', { field: 'hasAgreedToPrivacyTIN', value: true });
            this.toggle_privacy = false; // Close privacy modal
            if (this.nextActionTIN) {
                this.nextActionTIN(); // Execute the stored action (open TIN modal)
                this.nextActionTIN = null; // Clear the stored action
            }
        },
        handlePrivacyAgreementPIN() {
            this.$store.commit('updateHasAgreedToPrivacy', { field: 'hasAgreedToPrivacyPIN', value: true });
            this.toggle_privacy = false; // Close privacy modal
            if (this.nextActionPIN) {
                this.nextActionPIN(); // Execute the stored action (open PIN modal)
                this.nextActionPIN = null; // Clear the stored action
            }
        },
        handleDateUpdate({ year, month, day }) {
            this.selected_year = year;
            this.selected_month = month;
            this.selected_day = day;
        },
        handleTIN(value) {
            this.inputted_tin = true;
            let tinString = value.join('');
            let formatted_tin = tinString.replace(/(\d{3})(?=\d)/g, '$1-');
            this.tin_value = formatted_tin;
        },
        updateDigits() {
            this.inputted_tin = false;
        },
        logout() {
            this.$emit('logout');
        },
        maskData(data, type) {
            if (!data) return '';
            let maskedData = data.split('');
            const length = data.length;

            switch (type) {
                case 'name': {
                    const words = data.split(' ');
                    return words.map(word => {
                        const wordLength = word.length;
                        const maskLength = Math.floor(wordLength / 2);
                        const start = Math.floor((wordLength - maskLength) / 2);
                        let wordMaskedData = word.split('');
                        for (let i = start; i < start + maskLength; i++) {
                            wordMaskedData[i] = '*';
                        }
                        return wordMaskedData.join('');
                    }).join(' ');
                }
                case 'account':
                case 'serial': {
                    const maskLength = Math.floor(length / 2);
                    const start = Math.floor((length - maskLength) / 2);
                    for (let i = start; i < start + maskLength; i++) {
                        maskedData[i] = '*';
                    }
                    return maskedData.join('');
                }
                case 'mobile': {
                    const visibleStart = 4;
                    const visibleEnd = 3;
                    const maskLength = length - visibleStart - visibleEnd;
                    const start = visibleStart;
                    for (let i = start; i < start + maskLength; i++) {
                        maskedData[i] = '*';
                    }
                    return maskedData.join('');
                }
                case 'email': {
                    const [localPart, domain] = data.split('@');
                    const localPartMasked = localPart.split('').map((char, index) => {
                        return index > 0 && index < localPart.length - 1 && Math.random() > 0.5 ? '*' : char;
                    }).join('');
                    const domainMasked = domain.split('').map((char, index) => {
                        return index > 0 && index < domain.length - 1 && Math.random() > 0.5 ? '*' : char;
                    }).join('');
                    return `${localPartMasked}@${domainMasked}`;
                }
                case "birthdate": {
                    const digits = data.replace(/\//g, "").split("");
                    const maskLength = 4;
                    const maskIndices = new Set();

                    while (maskIndices.size < maskLength) {
                        const randomIndex = Math.floor(Math.random() * digits.length);
                        maskIndices.add(randomIndex);
                    }

                    maskIndices.forEach((index) => {
                        digits[index] = "*";
                    });

                    let maskedIndex = 0;
                    return data.split("").map((char) => (char === "/" ? "/" : digits[maskedIndex++])).join("");
                }
                case 'tin': {
                    const digits = data.replace(/-/g, '').split('');
                    const maskLength = Math.floor(Math.random() * 2) + 4;
                    const maskIndices = new Set();

                    while (maskIndices.size < maskLength) {
                        const randomIndex = Math.floor(Math.random() * digits.length);
                        maskIndices.add(randomIndex);
                    }


                    maskIndices.forEach(index => {
                        digits[index] = '*';
                    });


                    let maskedIndex = 0;
                    return data.split('').map(char => (char === '-' ? '-' : digits[maskedIndex++])).join('');
                }

                default:
                    return data;
            }
        },
        toggleVisibility(field) {
            this[`show${field.charAt(0).toUpperCase() + field.slice(1)}`] = !this[`show${field.charAt(0).toUpperCase() + field.slice(1)}`];
        },
    }
};

</script>

<style scoped>
.papsi-mascot {
    bottom: 0;
    left: 0;
    width: 25rem;
}

.papsi-container {
    height: 39rem;
}

.cards-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
}

.cards-grid-top {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(1, 1fr);
    gap: 1rem;
}


@media (min-width: 2500px) {
    .container {
        height: auto;
    }

    .icon {
        width: 3rem !important;
        height: 3rem !important;
    }

    .p-3 {
        padding: 2rem !important;
    }

    .w-48 {
        width: 18rem !important;
    }

    .h-8 {
        width: 3rem !important;
        height: 3rem !important;
        margin-top: 0.5rem !important;
    }
}
</style>